import { AppAPIBase } from 'libs/oac/abstracts/appAPIBase';

class AppAPI extends AppAPIBase {
  getSearchSettings() {
    return this.get(this.endpoint('search.settings'));
  }
  search(query, page, itemsPerPage) {
    return this.post(
      this.endpoint('search.search', { page, itemsPerPage }),
      query,
    );
  }
}

export { AppAPI };
